export default "__VITE_ASSET__DEuDaPeK__"